import { render } from "./EonOutlinedButton.vue?vue&type=template&id=5a9d4d51"
import script from "./EonOutlinedButton.vue?vue&type=script&lang=js"
export * from "./EonOutlinedButton.vue?vue&type=script&lang=js"

import "./EonOutlinedButton.vue?vue&type=style&index=0&id=5a9d4d51&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__